export const EXTERNAL_LAYERS_BEFORE_ID = 'wd-inject-external-layers-below';
